import * as Yup from "yup";

const baseProductFields = {
  title: Yup.string().required("Product title is required"),
  subTitle: Yup.string().required("Product subtitle is required"),
};

export const productValidationSchema = Yup.object({
  ...baseProductFields,
  thumbnail: Yup.mixed().required("Thumbnail image is required"),
  bulkImages: Yup.array()
    .min(1, "At least one product image is required")
    .required("Product images are required"),
});

export const productEditValidationSchema = Yup.object({
  ...baseProductFields,
  thumbnail: Yup.mixed(),
  bulkImages: Yup.array(),
});
